import { isObject } from 'vega-util';
var number = function number(_) {
  return +_ || 0;
};
var paddingObject = function paddingObject(_) {
  return {
    top: _,
    bottom: _,
    left: _,
    right: _
  };
};
export default function (_) {
  return isObject(_) ? {
    top: number(_.top),
    bottom: number(_.bottom),
    left: number(_.left),
    right: number(_.right)
  } : paddingObject(number(_));
}